import React from "react";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import * as Styles from "../../../../../../common-deprecated/styles/v2/lexus/components/FinanceToggle";
import { BnbLabel } from "../../../utils/labels";
import { setFinanceOption } from "../../../../../../common-deprecated/redux/actions/UtilActions";
import type { FinanceOptionType } from "../../../../../../common-deprecated/types/CommonTypes";
import { showBnbMonthlyRates } from "../../../utils/settings/bnbFinanceSettingUtils";
import { trackFinanceToggle } from "../../../utils/tracking";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type FinanceTogglePropsType = {
    modelCode: string;
};

const FinanceToggle = (props: FinanceTogglePropsType): JSX.Element | null => {
    const { modelCode } = props;

    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const step = useBnbSelector((state) => state.navigation.step);
    const showMonthlyRates = useBnbSelector((state) =>
        showBnbMonthlyRates(state.commonSettings, state.bnbSettings, modelCode, state.navigation.step),
    );
    if (!showMonthlyRates) return null;

    const onClickFn =
        (option: FinanceOptionType): (() => void) =>
        () => {
            if (option !== financeOption) {
                trackFinanceToggle(step, option, "cc-action");
                dispatch(setFinanceOption(option));
            }
        };

    return (
        <Styles.Wrapper fullWidth isMonthlyActive={financeOption === "monthly"}>
            <Styles.ToggleItem onClick={onClickFn("cash")} isActive={financeOption === "cash"}>
                <Styles.LineClamp>
                    <BnbLabel label="financeOptionCash" />
                </Styles.LineClamp>
            </Styles.ToggleItem>
            <Styles.ToggleItem onClick={onClickFn("monthly")} isActive={financeOption === "monthly"}>
                <Styles.LineClamp>
                    <BnbLabel label="financeOptionMonthly" />
                </Styles.LineClamp>
            </Styles.ToggleItem>
        </Styles.Wrapper>
    );
};

export default FinanceToggle;
